/**
 * Labstep - Table Handle Component
 *
 * Individual row and column handles for table manipulation
 */

import type { TableRowColumnHandleProps } from 'labstep-web/prosemirror/components/TableHandles/types';
import type React from 'react';
import { type FC, useCallback, useRef, useState } from 'react';
import styles from './styles.module.scss';

export const TableRowColumnHandle: FC<TableRowColumnHandleProps> = ({
  position,
  size,
  type,
  onMenuOpen,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleRef = useRef<HTMLDivElement>(null);

  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      event.preventDefault();
      event.stopPropagation();

      const rect = handleRef.current?.getBoundingClientRect();
      if (rect) {
        onMenuOpen({
          top: rect.bottom + 5,
          left: rect.left,
        });
      }
    },
    [onMenuOpen],
  );

  return (
    <div
      ref={handleRef}
      className={styles.rowColumnHandle}
      style={{
        top: position.top,
        left: position.left,
        width: size.width,
        height: size.height,
        background: isHovered
          ? 'rgba(219, 224, 232, 0.9)'
          : undefined,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
      title={`Click for ${type} options`}
    >
      {type === 'row' ? '⋮' : '⋯'}
    </div>
  );
};
